import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-accordionheader',
    toggleicon: 'p-accordionheader-toggle-icon'
};

export default BaseStyle.extend({
    name: 'accordionheader',
    classes
});
